import { Button } from '@mui/material';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  &.MuiButton-root {
    font-size: ${({ theme }) => theme.fontSize.body2};
    font-weight: ${({ theme }) => theme.fontWeight.medium};
    font-style: normal;
    display: flex;
    padding: ${({ theme }) => theme.spacing.s2}
      ${({ theme }) => theme.spacing.s2};
    justify-content: center;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.s2};
    letter-spacing: 0.032px;

    /* Semantic Border Radius */
    border-radius: var(--radius-md);

    /* Semantic Font Family */
    font-family: var(--font-family-primary);

    /* Tertiary Button Default State */
    background-color: var(--bg-surface); /* Replaced COLORS.white */
    color: var(--text-primary) !important; /* Replaced COLORS.kinetikBlack */
    border: 1px solid var(--border-color); /* Replaced COLORS.black20 */
    path {
      fill: var(--text-primary); /* Replaced COLORS.kinetikBlack */
    }
  }

  &.MuiButton-root:hover {
    border: 1px solid var(--text-secondary); /* Replaced COLORS.black40 */
    background-color: var(--bg-app); /* Replaced COLORS.black06 */
  }

  &.MuiButton-root:active {
    border-color: var(--primary-action-color); /* Replaced COLORS.kinetikBlue */
    background-color: var(--bg-surface); /* Replaced COLORS.white */
  }

  &.MuiButton-root.Mui-disabled {
    border: 1px solid var(--border-color); /* Replaced COLORS.black20 */
    background-color: var(--bg-surface); /* Replaced COLORS.white */
    color: var(--text-disabled) !important; /* Replaced COLORS.black20 */
    path {
      fill: var(--text-disabled); /* Replaced COLORS.black20 */
    }
  }
`;
